import type { FaireProductEntity } from "../../entity_types/product";

export const p_u7phhdyhub: FaireProductEntity = {
  token: "p_u7phhdyhub",
  type: "product",
  name: "Old Fashioned Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1c8711e4904a36f67757440724bce89c23a8c204b4e628be2f320a2e8875a062.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3999efb5ae91993349d50df3e89a751698a83a0f1ad216015078b4ed12dbe42c.png",
    "https://cdn.faire.com/fastly/2e94d549a13ab1c695f49d8ecda3e3d5093891f1b489603de5b05339a65a1e75.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:19.228Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
